import React, { useEffect, useState } from "react";

const BannerModal = ({ showBanner, setShowBanner }) => {
  useEffect(() => {
    setTimeout(() => {
      setShowBanner(true);
    }, 5000);
  }, []);
  return (
    <>
      {
        <div
          className={`w-full h-full flex justify-center items-center fixed top-0 left-0 z-[10000] 
            ${showBanner ? "scale-100 opacity-100" : "scale-0 opacity-0"} 
            transform transition-all duration-500`}
        >
          <div className="w-full h-full absolute bg-black opacity-80 z-100 top-0 left-0"></div>
          <div className="relative flex w-[90%] md:w-fit h-fit md:h-[80vh] bg-white">
            <img
              className="w-full h-full object-contain"
              src={
                process.env.PUBLIC_URL +
                "/images/Bannernotification/recent_banner.jpg"
              }
              alt="Visit us on London Book Fare (March 10-12,2026 at Stall 5E116)"
            />
            <button
              title="Close"
              tabIndex="0"
              onClick={() => setShowBanner(false)}
              className="absolute -right-5 -top-10 px-4 py-2 text-white z-10"
            >
              X
            </button>
          </div>
        </div>
      }
    </>
  );
};

export default BannerModal;
